import { render, staticRenderFns } from "./AdminJobsList.vue?vue&type=template&id=706986d9&scoped=true"
import script from "./AdminJobsList.vue?vue&type=script&lang=js"
export * from "./AdminJobsList.vue?vue&type=script&lang=js"
import style0 from "./AdminJobsList.vue?vue&type=style&index=0&id=706986d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706986d9",
  null
  
)

export default component.exports